/**
 * Safe localStorage wrapper with error handling
 * Prevents app crashes when localStorage is disabled, full, or unavailable
 */
export const storage = {
  /**
   * Safely get an item from localStorage
   * @param key - The key to retrieve
   * @returns The value or null if not found/error
   */
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Failed to read from localStorage:', error);
      return null;
    }
  },
  
  /**
   * Safely set an item in localStorage
   * @param key - The key to set
   * @param value - The value to store
   * @returns true if successful, false if failed
   */
  setItem: (key: string, value: string): boolean => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.error('Failed to write to localStorage:', error);
      return false;
    }
  },
  
  /**
   * Safely remove an item from localStorage
   * @param key - The key to remove
   * @returns true if successful, false if failed
   */
  removeItem: (key: string): boolean => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Failed to remove from localStorage:', error);
      return false;
    }
  },

  /**
   * Check if localStorage is available
   * @returns true if localStorage is available and working
   */
  isAvailable: (): boolean => {
    try {
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }
}; 